import { Layout } from 'antd';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Logout } from 'components/common';
import { AuthRoute, PrivateRoute } from 'routes';
import { useGoogleAnalytics } from 'hooks';
import * as Pages from 'pages';

const { Content } = Layout;

export default function Router() {
	useGoogleAnalytics();

	return (
		<Layout style={{ minHeight: '100vh' }}>
			<Content>
				<Switch>
					{/* Unauth routes start here */}
					<AuthRoute exact path={['/home', '/']}>
						<Pages.Landing />
					</AuthRoute>
					{/* Unauth routes ends here */}
					<AuthRoute exact path="/login">
						<Pages.SalesLoginForm />
					</AuthRoute>
					<AuthRoute exact path="/logins">
						<Pages.Login />
					</AuthRoute>
					{/* authenticated pages starts */}
					<PrivateRoute exact path="/collection">
						<Pages.Collection />
					</PrivateRoute>
					<PrivateRoute exact path="/sales-men">
						<Pages.SalesMen />
					</PrivateRoute>
					<PrivateRoute exact path="/store">
						<Pages.StorePayment />
					</PrivateRoute>
					<PrivateRoute exact path="/leave-management">
						<Pages.LeaveManagement />
					</PrivateRoute>
					<PrivateRoute exact path="/add-leave">
						<Pages.AddLeave />
					</PrivateRoute>
					<PrivateRoute exact path="/invoices-collection">
						<Pages.SalesmanDashboard />
					</PrivateRoute>
					<PrivateRoute exact path="/outlet">
						<Pages.OutletPayment />
					</PrivateRoute>
					<PrivateRoute exact path="/salesmenlist">
						<Pages.SalesamanList />
					</PrivateRoute>
					{/* authenticated pages ends */}
					<Route path="*">
						<Pages.NotFound />
					</Route>
				</Switch>
				<Logout />
			</Content>
		</Layout>
	);
}
